import { jsx as _jsx } from "react/jsx-runtime";
const Loader = () => {
    return _jsx("div", { className: "loader" });
};
export default Loader;
